export interface IHomePageStoreState {
  // ! this can spliced off into separate reducer altogether
  offersApi: IOffersApi;
  homeSeoData: ISeoData;
  campaignData: ICampaignData;
}

export interface ISeoData {
  h1: string;
  title: string;
}

export interface IOffersApi {
  isLoading: boolean;
  data: Array<ISlug>;
}

export interface ISlug {
  slug: string;
  url: string;
  sub_heading: string;
  validity_text: string;
  img_url: string;
  order: number;
}

export const UPDATE_OFFERS_DATA = 'UPDATE_OFFERS_DATA';
export const TOGGLE_LOADING_GETOFFERS = 'TOGGLE_LOADING_GETOFFERS';

export const UPDATE_HOME_SEO_DATA = 'UPDATE_HOME_SEO_DATA';

export const UPDATE_CAMPAIGN_DATA = 'UPDATE_CAMPAIGN_DATA';
export const TOGGLE_LOADING_CAMPAIGN = 'TOGGLE_LOADING_CAMPAIGN';
export const UPDATE_HEAD_CAMPAIGN_DATA = 'UPDATE_HEAD_CAMPAIGN_DATA';

export interface IUpdateSEOData {
  type: typeof UPDATE_HOME_SEO_DATA;
  homeSeoData: ISeoData;
}

export interface IUpdateOffersData {
  type: typeof UPDATE_OFFERS_DATA;
  actionData: IOffersApi['data'];
}

export interface IToggleLoadingGetOffersData {
  type: typeof TOGGLE_LOADING_GETOFFERS;
  actionData: IOffersApi['isLoading'];
}

export interface ICampaignloading {
  type: typeof TOGGLE_LOADING_CAMPAIGN;
  actionData: ICampaignData['isLoading'];
}

export interface ICampaignData {
  isLoading: boolean;
  data: Array<ICampaign>;
  headData: Array<ICampaignHeadData>;
}

export interface ICampaign {
  city_id: number;
  city_name: string;
  description: string;
  h_text: string;
  image_url: string;
}

export interface IUpdateCampaignData {
  type: typeof UPDATE_CAMPAIGN_DATA;
  actionData: ICampaignData['data'];
}

export interface ICampaignHeadData {
  heading: string;
  sub_heading: string;
}

export interface IUpdateCampaignHeadData {
  type: typeof UPDATE_HEAD_CAMPAIGN_DATA;
  actionData: ICampaignHeadData['data'];
}


export type HomePageActionTypes = IUpdateOffersData | IToggleLoadingGetOffersData | IUpdateCampaignData | ICampaignloading | IUpdateCampaignHeadData;
